import React from 'react';
import { ExclamationTriangleIcon, BoltIcon } from '@heroicons/react/24/outline';
import { Session } from '../utils/api';

interface ForceDisconnectModalProps {
  session: Session;
  isDisconnecting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ForceDisconnectModal: React.FC<ForceDisconnectModalProps> = ({
  session,
  isDisconnecting,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex items-center justify-center mb-4">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
            </div>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-medium leading-6 text-gray-900 mb-2">
              Force Disconnect Session?
            </h3>
            <div className="mt-2 px-7 py-3">
              <p className="text-sm text-gray-500 mb-3">
                You are about to forcibly disconnect the session:
              </p>
              <p className="text-sm font-semibold text-gray-900 mb-1">
                {session.session_name || 'Unnamed Session'}
              </p>
              <p className="text-xs text-gray-500 mb-3">
                Host: {session.host_display_name} → Client: {session.client_display_name}
              </p>
              <p className="text-sm text-red-600">
                This action will immediately terminate the VPN connection for both users. This cannot be undone.
              </p>
            </div>
            <div className="flex items-center justify-center gap-4 px-4 py-3">
              <button
                onClick={onCancel}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                disabled={isDisconnecting}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
              >
                <BoltIcon className="h-4 w-4" />
                {isDisconnecting ? 'Disconnecting...' : 'Force Disconnect'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForceDisconnectModal;
